import { defineStore } from "pinia";
import type { ServicesRequest, ServicesProductResponse, ServicesNominalResponse, ServicesProduct, ServicesNominal, inquiryServicesRequest, InquiryServicesResponse, transactionRequest, transactionResponse, getReportResponse } from "~/istypes";
import { useUserStore } from "~/stores/user";

export const useServicesStore = defineStore('services', () => {
    const config = useRuntimeConfig();
    const servicesList = ref<ServicesProduct[]>([]);
    const hardcodeServices = ref([
        { id: 93, label: "Tagihan Telepon", iconClass: "fa-solid fa-phone", url: "produk-digital/tagihan-telepon" },
        { id: 87, label: "PLN Prabayar", iconClass: "fa-solid fa-bolt-lightning", url: "produk-digital/pln-prabayar" },
        { id: 86, label: "PLN Pascabayar", iconClass: "fa-solid fa-bolt-lightning", url: "produk-digital/pln-pascabayar" },
        { id: 96, label: "TV Berlangganan", iconClass: "fa-solid fa-tv", url: "produk-digital/tagihan-tv" },
        { id: 81, label: "Tagihan Internet", iconClass: "fa-solid fa-house-signal", url: "produk-digital/tagihan-internet" },
        { id: 78, label: "Multi Finance", iconClass: "fa-solid fa-id-card", url: "produk-digital/multifinance" },
        { id: 83, label: "PDAM / PALJAYA", iconClass: "fa-solid fa-droplet", url: "produk-digital/pdam" },
        { id: 71, label: "BPJS Kesehatan", iconClass: "fa-solid fa-user-shield", url: "produk-digital/bpjs" },
    ]);
    const productList = ref<ServicesNominal[]>([]);
    const InformasiHarga = ref();
    const selectedService = ref();

    const userStore = useUserStore();

    const setServices = (data?: any) => (servicesList.value = data);
    const setProduct = (data?: any) => (productList.value = data);
    const setInformasiHarga = (data?: any) => (InformasiHarga.value = data);

    const ServiceLayanan = async (data: ServicesRequest) => {
        const headers: Record<string, string> = {};
        
        headers["Device-Id"] = userStore.deviceId();

        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }
        try {
            const res = await $fetch<ServicesProductResponse>(`${config.public.ApiBase}/ppob/services`, {
                method: "POST",
                body: data,
                headers
            });

            if (res.status?.code === 200)
                setServices(res.details);

            return res;
        } catch (error) {
            setServices();
        }
    };

    const ProductLayanan = async (data: ServicesRequest) => {
        const headers: Record<string, string> = {};
            
        headers["Device-Id"] = userStore.deviceId();

        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }
       try {
           const res = await $fetch<ServicesNominalResponse>(`${config.public.ApiBase}/ppob/services/products`, {
               method: "POST",
               body: data,
               headers
           });

           if (res.status?.code === 200)
               setProduct(res.details);

           return res;
       } catch (error) {
           setProduct();
       }
    };

    const fetchInformasiHarga = async (data: inquiryServicesRequest) => {
        const headers: Record<string, string> = {};
        
        headers["Device-Id"] = userStore.deviceId();

        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }
        try {
            const res = await $fetch<InquiryServicesResponse>(`${config.public.ApiBase}/ppob/inquiry`, {
                method: "POST",
                body: data,
                headers
            });

            if (res.status?.code == 200) {
                setInformasiHarga(res.details?.data);
            }

            return res;
        } catch (error) {
            setInformasiHarga();
        }
    };

    const transaction = async (data: transactionRequest) => {
        if (userStore.token) {
            try {
                const res = await $fetch<transactionResponse>(`${config.public.ApiBase}/ppob/transaction`, {
                    method: "POST",
                    body: data,
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportList = async (start_date: Date | null, end_date: Date | null) => {
        if (userStore.token) {
            try {
                const res = await $fetch<getReportResponse>(`${config.public.ApiBase}/ppob/reports`, {
                    method: "POST",
                    body: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportDetail = async (id: number | string) => {
        if (userStore.token) {
            try {
                const res = await $fetch<getReportResponse>(`${config.public.ApiBase}/ppob/reports/detail`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                         "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    return { servicesList, productList, InformasiHarga, selectedService, hardcodeServices, setServices, setProduct, setInformasiHarga, ServiceLayanan, ProductLayanan, fetchInformasiHarga, transaction, getReportList, getReportDetail };
});
